<template lang="pug">
  div.interaction-rightbar.mb-2.py-3
    div
      div.mb-0.px-3
        // this section is currently 'live'
        // fields added as user input them
        h5.mb-1(style='color:#536c79')
          | User Info
        div(v-if="userInfo")
          // online status
          div(v-if="userInfo.status")
            span
              i.text-muted {{ onlineStatus }}
            div.avatar(style="width: 14px; top: 1px;")
              span.avatar-status(:class='userInfo ? "bg-" + userInfo.status : "bg-danger"')
            br
          // shortID
          // TODO: temporarily disabling shortID cus some of them dont have
          // div(v-if="shortID")
          //  | short ID: {{ userInfo.shortID }}
          // circle profile pic
          // name
          div(v-if="name")
            | Name: {{ name }}
          div(v-if="preferredName")
            | Preferred Name: {{ preferredName }}
          // platform?
          // email
          div(v-if="email")
            | Email: {{ email || userEmail }}
          // any other info like phone number, gender, age etc
          div(v-if="userLineNumber")
            | giga Number: {{ userLineNumber }}
          div(v-if="osUserId")
            | OutSystems User ID: {{ osUserId }}
          div(v-if="mtxUserId")
            | Matrixx User ID: {{ mtxUserId }}
      hr

    // TODO: show uploadedPics if there are
    div(v-if="uploadedPics.length")
      div.mb-0.px-3
        h5.mb-1(style='color:#536c79')
          | Media
          // uploaded pics
          // if uploaded-pics.length === 0, dont display this column
      hr

    div
      div.mb-0.px-3
        // this section is currently 'live'
        // fields added as user input them
        h5.mb-1(style='color:#536c79')
          | CRM Info
        div(v-if="userInfo")
          // shortID
          // TODO: temporarily disabling shortID cus some of them dont have
          // div(v-if="shortID")
          //  | short ID: {{ userInfo.shortID }}
          // circle profile pic
          // name
          div(v-if="CRMname")
            | Name: {{ CRMname }}
          // platform?
          // email
          div(v-if="CRMemail")
            | Email: {{ CRMemail }}
          // any other info like phone number, gender, age etc
      hr

    div
      div.mb-0.px-3
        span.add-note-button(@click="addNoteClickHandler")
          | Add Note
        h5.mb-3(style='color:#536c79; margin')
          | Notes
        b-form-textarea.mb-1(
          ref="note-input"
          v-if="displayAddNoteTextarea"
          v-model='addNoteText'
          :rows='3'
          :max-rows='6'
          @keyup.enter.native='handleEnter'
          @keyup.esc.native='hideAddNoteTextarea'
          placeholder='Jot down something...'
          style="resize: none;"
        )
        div(v-if="notes.length==0 && !displayAddNoteTextarea")
          i.text-muted No notes available
        div.note(v-for="(note, index) in notesReversed" v-else)
          div.note-text(v-html="replaceNewlineToBr(note.text)")
          div.note-others
            span
              | {{ formatTimeAgo(note.timestamp) }}
            span
              |&nbsp;·&nbsp;
            span.delete-note-button(@click="deleteNote(note.id)")
              | Delete
          hr(v-if="index!=notes.length-1")
      hr

    div(style='position: absolute; bottom: 40px;text-align: center;width: 100%;margin: 5px')
      div.mb-2.px-3
        b-button(@click='showPropt = true' variant='danger')
          | Create New Service Request
    b-modal(v-model='showPropt', title='Create New Service Request')
      b-form(id="complainForm" @submit="checkForm")
        span(v-if="errors.length")
          | Please correct the following error(s):
          ul
            li(v-for="error in errors")
              | {{ error }}
        span Mobile Number
        b-input(id="mobileNumber" v-model="mobileNumber" type="text" name="mobileNumber" placeholder="Enter Mobile Number")
        span Request Type
        //- this should be dropdown
        //- b-input(id="requestType" v-model="requestType" type="text" name="requestType" placeholder="Enter Request Type")
        b-form-select(id="requestType" v-model="requestType" name="requestType" placeholder="Select Request Type" :options="requestTypeOptions")
          template(slot="first")
            option(:value="null" disabled) -- Please select a Request Type --
        span Comment
        b-textarea(id="comment" v-model="comment" type="text" name="comment" rows="3" placeholder="Enter Comment")
        span User ID
        b-input(id="userID" v-model="userID" type="text" name="userID" placeholder="Enter User ID" disabled)
        span Email
        b-input(id="email" v-model="email" type="text" name="email" placeholder="Enter Email")
        span Name
        b-textarea(id="name" v-model="name" type="text" name="name" placeholder="Enter Name")
      div(slot='modal-footer')
        b-button.float-right.ml-1(type='button', variant='outline-primary', @click='showPropt = false;')
          | Cancel
        b-button.float-right.ml-1(@click='checkForm', variant='primary')
          | Submit

</template>

<script>
import {
  streamUserInfo,
  getUploadedPics,
  AgentNotes,
  cleanupStreamingRefs,
} from '@/dbApi'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { replaceNewlineToBr } from '@/utility/textToHTMLHelpers'
import { fullNameElseID } from '../utility/preferUserName'
dayjs.extend(relativeTime)

export default {
  name: 'interaction-rightbar',
  data() {
    return {
      userID: null,
      userInfo: null,
      // cleaned data
      name: null,
      preferredName: null,
      email: null,
      CRMname: null,
      CRMemail: null,
      shortID: null,
      // profilePic: null,
      uploadedPics: [],
      notes: [],
      // decide if to show textarea
      displayAddNoteTextarea: false,
      addNoteText: '',
      dayjs,
      showPropt: false,
      mobileNumber: null,
      requestType: null,
      comment: null,
      errors: [],
      requestTypeOptions: ['Registration', 'Account', 'Events', 'E-learning course', 'Website', 'Others'],
    }
  },
  computed: {
    notesReversed() {
      return this.notes.slice().reverse()
    },
    onlineStatus() {
      // cases
      // - online
      // - offline, with lastOnline field
      // - offline, without lastOnline field
      const { status, lastOnline } = this.userInfo
      let statusText = ''
      if (status == 'success') {
        statusText = 'currently online'
      } else {
        statusText = lastOnline ? `last seen ${this.formatTimeAgo(lastOnline)}` : 'offline'
      }
      return statusText
    },
  },
  methods: {
    checkForm: function (e) {
      if (this.mobileNumber && this.requestType && this.name && this.email && this.userID) {
        // const timestamp = Date.now().toString()
        // const update = {
        //   mobileNumber: this.mobileNumber,
        //   requestType: this.requestType,
        //   comment: this.comment,
        //   userID: this.userID,
        //   platform: 'enchatment',
        //   timestamp,
        //   openAgentID: this.$store.state.profile.uniqueID,
        //   email: this.email,
        //   name: this.name,
        // }
        this.showPropt = false
        // openServiceRequest(update)
        return true
      }

      this.errors = []

      if (!this.mobileNumber) {
        this.errors.push('Mobile Number required.')
      }
      if (!this.requestType) {
        this.errors.push('Request Type required.')
      }

      e.preventDefault()
    },
    extractUserInfo(userInfo) {
      if (userInfo) {
        this.shortID = userInfo.shortID
      }
      this.preferredName = fullNameElseID(null, userInfo) || ''
      this.userLineNumber = userInfo.userLineNumber || ''
      this.osUserId = userInfo.osUserId || ''
      this.mtxUserId = userInfo.matrixUserId || ''
      // extraction from orderInfoByText
      if (userInfo && userInfo.orderInfoByText) {
        const info = userInfo.orderInfoByText
        this.name = info.name || ''
        this.email = info.email || ''
        this.CRMname = info.name || ''
        this.CRMemail = info.email || ''
      }
      if (userInfo && userInfo.userName) {
        this.name = userInfo.userName
      } else if (userInfo && userInfo.firstName && userInfo.lastName) {
        this.name = userInfo.firstName + ' ' + userInfo.lastName || ''
      } else if (userInfo && userInfo.name) {
        this.name = userInfo.name
      }
      if (userInfo && userInfo.userEmail) {
        this.email = userInfo.userEmail
      } else if (userInfo && userInfo.email) {
        this.email = userInfo.email
      }

      // disable for now as no profile picture is required
      // if (userInfo && userInfo.profilePic) {
      //   this.uploadedPics.push(userInfo.profilePic)
      // }
    },
    async deleteNote(noteID) {
      // remove visual element
      this.notes = this.notes.filter((note) => {
        return note.id !== noteID
      })
      // call api to delete
      const agentNotes = AgentNotes(this.userID)
      await agentNotes.delete(noteID)
    },
    async addNote() {
      const noteText = this.addNoteText.trim()
      // hide add note, clear addNoteText
      this.hideAddNoteTextarea()
      this.addNoteText = ''
      // add visual element
      const note = { text: noteText, timestamp: Date.now() }
      this.notes.push(note)
      // call api to push
      const agentNotes = AgentNotes(this.userID)
      const noteID = await agentNotes.push(note)
      note.id = noteID
    },
    formatTimeAgo(timestamp) {
      return dayjs(timestamp).from(dayjs())
    },
    replaceNewlineToBr(str) {
      return replaceNewlineToBr(str)
    },
    showAddNoteTextarea() {
      this.displayAddNoteTextarea = true
    },
    hideAddNoteTextarea() {
      this.displayAddNoteTextarea = false
    },
    focusTextarea() {
      this.$refs['note-input'].focus()
    },
    addNoteClickHandler() {
      this.showAddNoteTextarea()
      this.$nextTick(function() {
        this.focusTextarea()
      })
    },
    async grabData() {
      const { userID } = this
      streamUserInfo(userID, (userInfo) => {
        this.userInfo = userInfo
        this.extractUserInfo(userInfo)
      })

      const uploadedPics = getUploadedPics()
      this.uploadedPics = uploadedPics

      const agentNotes = AgentNotes(userID)
      const notes = await agentNotes.get()
      this.notes = notes
    },
    cleanup() {
      // clear previous interaction's userInfo
      // this.clearPreviousUserInfo()
      // cleanup firebase' on('value')
      cleanupStreamingRefs()
    },
    handleEnter(event) {
      event.preventDefault()
      // handles cases for shift-enter, only submit when it's pure enter
      if (!event.shiftKey) {
        this.addNote()
      }
    },
  },
  // TODO: refactor common codes in mounted & watch
  async mounted() {
    // const that = this
    const path = this.$route.path
    const userID = path.split('/')[2]
    this.userID = userID

    this.grabData()
    // grab the things we need
    const complainForm = document.getElementById('complainForm')

    // listen for the submit event
    complainForm.addEventListener('submit', processComplainForm)
    function processComplainForm(e) {
      e.preventDefault()
      // const timestamp = Date.now().toString()
      // const update = {
      //   mobileNumber: that.mobileNumber,
      //   requestType: that.requestType,
      //   comment: that.comment,
      //   userID: that.userID,
      //   platform: 'enchatment',
      //   timestamp,
      //   openAgentID: that.$store.state.profile.uniqueID,
      //   email: that.email,
      //   name: that.name,
      // }
      // console.log(update)
      // openServiceRequest(update)
      alert('Submitted.')
    }

    // await agentNotes.push({ text: 'hoolalala' })
  },
  watch: {
    async $route (to, from) {
      this.cleanup()

      const { path } = to
      const userID = path.split('/')[2]
      this.userID = userID

      this.grabData()
      // await agentNotes.push({ text: 'hoolalala' })
    },
  },
  beforeDestroy() {
    this.cleanup()
  },
}
</script>

<style scoped>
.card.no-bottom-margin {
  margin-bottom: 0px;
}

span.add-note-button {
  position: absolute;
  right: 1vw;
  color: #20a8d8;
}

span.add-note-button:hover {
  cursor: pointer;
  text-decoration: underline;
}

div.note-text {

}

div.note-others {
  font-size: 10px;
  color: #536c79;
}

span.delete-note-button:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/fragments/interactionsRightbar.vue?12182bdb